import styled from 'styled-components';
import { rem } from 'polished';
import Input from '../../core/Input';

export const StyledModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledModalContent = styled.div`
  background-color: #fff;
  width: ${rem('800px')};
  height: ${rem('600px')};
  padding: ${rem('50px')};
  border-radius: ${rem('5px')};
  display: block;
`;

export const StyledInput = styled(Input)`
  margin-bottom: ${rem('20px')};
  width: ${rem('325px')};
`;

export const StyledModalTitle = styled.h1`
  margin-left: ${rem('200px')};
  margin-bottom: ${rem('50px')};
`;

export const StyledInputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const StyledInputsGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledButtonsWrapper = styled.div`
  position: relative;
  top: ${rem('30px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledGrupButtonCheckBoxes = styled.div`
  position: relative;
  margin-bottom: ${rem('30px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  height: ${rem('200px')};
  max-height: ${rem('200px')};
  overflow-y: scroll;
`;

export const StyledErrorMessages = styled.p`
  color: red;
  font-size: ${rem('14px')};
`;

export const StyledSuccessMessages = styled.p`
  color: green;
  font-size: ${rem('14px')};
`;
